import { z } from 'zod';
import { SearchSchema } from '@anytag/shared-validations';
import { TwitterAnalyticsPostsSortOrder } from '@anytag/graphql';
import { defaultProfilePostsFilterSchema } from '@anytag/shared-organisms';

export const AnalyticsTwitterPostsSearchSchema = SearchSchema.create({
  filter: defaultProfilePostsFilterSchema,
  sort: { field: TwitterAnalyticsPostsSortOrder }
});

export type AnalyticsTwitterPostsSearchSchemaType = z.infer<typeof AnalyticsTwitterPostsSearchSchema>;
